// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"PathSidebar_fieldWrapper__JcKlf","pathList":"PathSidebar_pathList__PM_V3","sectionWrapper":"PathSidebar_sectionWrapper__pPHOq"};